import React from 'react'
import { useTranslation } from 'react-i18next'

import { DataTable } from 'primereact/datatable'

import { TableConfig } from '../../../../features/ui-config'
import { createLoadingColumns } from './createLoadingColumns'

type Props = {
  config: TableConfig
  checkboxen?: boolean
  buttons?: JSX.Element
  hasLink?: boolean
  header?: JSX.Element | null
}
export const LoadingTable: React.FC<Props> = ({
  config,
  checkboxen,
  buttons,
  hasLink,
  header,
}) => {
  const { t } = useTranslation()
  // create loading items from the rows number in the config
  function createIdArray(count: number = 5) {
    const idArray = []
    for (let i = 1; i <= count; i++) {
      idArray.push({ LoadingId: i })
    }
    return idArray
  }

  return (
    <DataTable
      cellSelection={false}
      currentPageReportTemplate={t('common.table.numberOfEntries')}
      dataKey="LoadingId"
      filterDisplay="menu"
      header={header}
      paginator
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      removableSort
      rows={config.rows}
      rowsPerPageOptions={config.rowsPerPageOptions}
      scrollable
      scrollHeight="400px"
      selectionPageOnly
      showGridlines
      sortField={config.sortField}
      sortOrder={config.sortOrder}
      value={createIdArray(config.rows)}
    >
      {/* columns */}
      {createLoadingColumns(config.columns, checkboxen, buttons, hasLink)}
    </DataTable>
  )
}
